<template>
  <div class="mx-md-12 px-sm-12 align--center">
    <p class="display-1 primary--text text-center">Heimentgelte</p>

    <p>
      <strong>Tagsatz für Einzelzimmer</strong> <br>
      159,89&euro; inklusive MwSt.
    </p>

    <p>
      <strong>Pflege- &amp; Betreuungszuschlag</strong><br>
      Das Pflege- &amp; Betreuungsgeld wird nach Bundespflegegesetz verrechnet und ist bis auf einen kleinen Betrag dem Sozialhilfeberband zu entrichtet.<br>
      N&auml;here Informationen finden Sie hier: <br>
      <a href="https://www.oesterreich.gv.at/themen/soziales/pflege/4.html" target="_blank">
        https://www.oesterreich.gv.at/themen/soziales/pflege/
      </a>
    </p>

    <p>
      <strong>Reservierungsbeitrag</strong><br>
      154,72&euro; inklusive MwSt. <br>
      Ab dem Zeitpunkt der fixen Anmeldung für einen Altenheimplatz wird
      gem. O.ö. Alten- und Pflegeheimverordnung ein Reservierungsbeitrag eingehoben,
      wenn das Zimmer erst später bezogen wird. Der Reservierungsbeitrag entspricht dem Heimentgelt
      abzüglich dem Lebensmitteleinsatz.
    </p>

    <p>
      <strong>Gemeinsames Mittagessen</strong><br>
      Gerne laden wir Sie zum gemeinsamen Essen im Wohnbereich ein. <br>
      Mittagessen: 8,99&euro; <br>
      Abendessen: 5,50&euro;
    </p>

    <p>
      Essen zu Hause inklusive Zustellung: 12,50&euro;<br>
      Bei Interesse suchen Sie bitte Erstkontakt bei Frau <strong>Sonja Stallinger</strong> am Gemeindeamt.<br>
      <a href="https://www.frankenburg.ooe.gv.at/Essen_zu_Hause_-_Anmeldung_1">Anmeldeformular Essen zu Hause</a>
    </p>

    <p color="gray">
      alle Preise ab 01.01.2026 - Änderungen vorbehalten
    </p>

  </div>
</template>

<script>
  export default {
    name: 'heimentgelte',
  }
</script>
